import "./bundle.scoped.config.js";

// eslint-disable-next-line import/first
import testAssets from "./bundle.esm.js";

export default testAssets;
